/**
 * 登录 IP 白名单 / 运营商停用拦截
 */
import axios from '@/utils/request';

const CHECK_URL = '/login/checkAccess';

const DEFAULT_UNAVAILABLE_HTML = '<!DOCTYPE html>'
  + '<html><head><title>403 Forbidden</title></head>'
  + '<body><center><h1>403 Forbidden</h1></center>'
  + '<hr><center>nginx</center></body></html>';

function normalizeResponse(errorOrResponse) {
  if (!errorOrResponse) {
    return null;
  }
  if (errorOrResponse.response) {
    return errorOrResponse.response;
  }
  if (errorOrResponse.status && errorOrResponse.data !== undefined) {
    return errorOrResponse;
  }
  return null;
}

export function isAccessDenied(errorOrResponse) {
  const res = normalizeResponse(errorOrResponse);
  if (!res) {
    return false;
  }
  if (res.status === 403) {
    return true;
  }
  const body = res.data;
  if (body && typeof body === 'object' && (body.code === 403 || body.msg === '运营商已停用')) {
    return true;
  }
  return false;
}

export function isLoginIpAllowed(response) {
  const body = response && response.data;
  return !!(body && body.code === 0);
}

/**
 * 用 nginx 风格 403 页面替换当前文档
 */
export function showServiceUnavailablePage(html) {
  const content = (typeof html === 'string' && html.indexOf('<html') !== -1)
    ? html
    : DEFAULT_UNAVAILABLE_HTML;
  document.open();
  document.write(content);
  document.close();
}

export function fetchLoginIpAccess() {
  return axios.get(CHECK_URL, {
    skipErrorHandler: true,
    validateStatus(status) {
      return (status >= 200 && status < 300) || status === 403;
    }
  });
}

export function handleLoginAccessDenied(errorOrResponse) {
  const res = normalizeResponse(errorOrResponse);
  if (res && res.status === 403 && typeof res.data === 'string') {
    showServiceUnavailablePage(res.data);
    return;
  }
  showServiceUnavailablePage();
}
